// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { FC, HTMLAttributes, createElement } from 'react'

import { cell } from './Cells'

export interface CellWrapperProps extends HTMLAttributes<HTMLElement> {
  dataIndex: string
  title: any
  type: string
  record: object
  index: number
  sorter: any
  defaultSortOrder: any
  render: (value: any, record: any) => void
  children: Node
  format: object

  shouldRender: boolean
}

const CellWrapper: FC<CellWrapperProps> = (props) => {
  const {
    children,
    type,
    shouldRender,
    dataIndex,
    render,
    sorter,
    defaultSortOrder,
    format,
    ...restProps
  } = props

  if (shouldRender || !props.title) {
    return <td {...restProps}>{children}</td>
  }
  return (
    <td {...restProps}>
      {cell[type] &&
        createElement(
          cell[type],
          {
            dataIndex,
            render,
            sorter,
            defaultSortOrder,
            format,
            ...restProps,
          },
          children,
        )}
    </td>
  )
}

export default CellWrapper
